export class RecentAbstractView {
    id: number;
    type: number;
    actionDate: Date;
    operatorId: number;


    constructor(data?: any) {
        this.id = data?.id ?? null;
        this.type = data?.type ?? -1;
        this.actionDate = data?.actionDate ? new Date(data.actionDate) : new Date();
        this.operatorId = data?.operatorId ?? -1;

        //initalise into classe that extend this class
        if (this.constructor === RecentAbstractView) {
            throw new Error("Cannot instantiate abstract class RecentAbstractView");
        }

    }
}